"use client";

// "use client" hoja interactiva: draft en localStorage + submit funcional (form GET a /chat) — necesita DOM.

// 2026-09-19 FASE 2 FIXER Hero split: isla del composer funcional del Hero
// (split de `Hero.tsx` sin cambio de conducta ni de DOM — mismo form GET,
// mismos testids/clases para el contrato `Hero.test.tsx`).
// Real composer (functional hero): native GET form — no JS needed, opens
// /chat with the prompt prefilled (?prompt=&autoSend=1): logged-out users land
// in the workspace behind the sign-in gate, logged-in users get the full
// workspace. + carries drafts
// to /chat for attachments. Nothing looks functional without working.
// P0 #1: guarda el draft en localStorage antes de navegar (el gate lo
// restaura tras login). Sin redirección directa a /signup para no romper el
// contrato GET ?prompt&autoSend (Hero.test).
// 2026-10-04 RUN13 FASE 2 trial removido: el handoff es ?prompt=&autoSend=1
// sin guest=1 (la prueba gratuita se eliminó; el gate de login decide).
import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { ArrowUp, Plus } from "lucide-react";
import { localePath } from "@/lib/i18n/locales";
import { useLocale, useT } from "@/lib/use-i18n";
import { probeOnline } from "@/lib/client-online";
import { savePendingPrompt } from "./hero-pending-prompt";
export function HeroComposer() {
  const $ = _c(57);
  const t = useT();
  const locale = useLocale();
  let t0;
  if ($[0] !== locale) {
    t0 = path => localePath(locale, path);
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const lp = t0;
  const promptRef = useRef(null);
  const [isOnline, setIsOnline] = useState(true);
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      let mounted = true;
      if (typeof navigator !== "undefined" && !navigator.onLine) {
        probeOnline().then(ok => {
          if (mounted && ok) {
            setIsOnline(true);
          }
        });
      }
      const on = () => setIsOnline(true);
      const off = () => {
        probeOnline().then(ok_0 => {
          if (mounted && !ok_0) {
            setIsOnline(false);
          }
        });
      };
      window.addEventListener("online", on);
      window.addEventListener("offline", off);
      return () => {
        mounted = false;
        window.removeEventListener("online", on);
        window.removeEventListener("offline", off);
      };
    };
    t2 = [];
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== isOnline || $[5] !== lp) {
    t3 = () => {
      if (!isOnline) {
        return;
      }
      const draft = promptRef.current?.value.trim() ?? "";
      savePendingPrompt(draft);
      const base = lp("/chat");
      window.location.assign(draft ? `${base}?prompt=${encodeURIComponent(draft)}` : base);
    };
    $[4] = isOnline;
    $[5] = lp;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleAttachHandoff = t3;
  let t4;
  if ($[7] !== isOnline) {
    t4 = e => {
      if (!isOnline) {
        e.preventDefault();
        return;
      }
      savePendingPrompt(promptRef.current?.value ?? "");
    };
    $[7] = isOnline;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleHeroSubmit = t4;
  let t5;
  if ($[9] !== lp) {
    t5 = lp("/chat");
    $[9] = lp;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <input type="hidden" name="autoSend" value="1" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("heroPromptLabel");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <label htmlFor="hero-prompt-input" className="sr-only">{t7}</label>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("howPreviewPrompt");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      minHeight: 40
    };
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t9) {
    t11 = <textarea ref={promptRef} id="hero-prompt-input" name="prompt" rows={1} required={true} maxLength={4000} autoComplete="off" placeholder={t9} enterKeyHint="send" style={t10} onKeyDown={_temp} className="vortixy-hero-prompt w-full resize-none overflow-y-auto max-h-40 bg-transparent border-0 p-2 text-base font-normal leading-snug text-foreground placeholder:text-muted-foreground [field-sizing:content] outline-none focus:outline-none focus-visible:outline-none focus-visible:ring-0 focus-visible:border-0 focus:shadow-none focus-visible:bg-[var(--muted)]/40 focus-visible:rounded-lg" />;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = !isOnline;
  let t13;
  if ($[21] !== t) {
    t13 = t("demoEditorCta");
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t) {
    t14 = t("demoEditorCta");
    $[23] = t;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Plus className="size-5" strokeWidth={2} aria-hidden="true" />;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== handleAttachHandoff || $[27] !== t12 || $[28] !== t13 || $[29] !== t14) {
    t16 = <button type="button" onClick={handleAttachHandoff} disabled={t12} aria-label={t13} title={t14} className="inline-flex size-11 sm:size-8 items-center justify-center rounded-full border border-[var(--border)] bg-transparent text-muted-foreground transition-[color,border-color,transform] duration-200 hover:text-foreground hover:border-[var(--border-strong)] active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-40">{t15}</button>;
    $[26] = handleAttachHandoff;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  const t17 = !isOnline;
  let t18;
  if ($[31] !== t) {
    t18 = t("heroCtaPrimary");
    $[31] = t;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <ArrowUp className="size-4" strokeWidth={2.5} aria-hidden="true" />;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t17 || $[35] !== t18) {
    t20 = <span className="flex items-center gap-2"><button type="submit" data-testid="hero-primary-cta" data-primary-cta="true" disabled={t17} aria-label={t18} className="inline-flex h-10 w-10 sm:h-8 sm:w-8 items-center justify-center rounded-full bg-foreground text-background shadow-sm transition-transform duration-200 hover:scale-105 active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-40 motion-reduce:transform-none motion-reduce:transition-none motion-reduce:hover:scale-100">{t19}</button></span>;
    $[34] = t17;
    $[35] = t18;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t16 || $[38] !== t20) {
    t21 = <div className="flex items-center justify-between gap-2 pt-1">{t16}{t20}</div>;
    $[37] = t16;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== isOnline || $[41] !== t) {
    t22 = !isOnline ? <p role="status" data-testid="hero-offline-note" className="pt-1 text-xs leading-6 text-muted-foreground">{t("offlineTitle")} — {t("offlineBody")}</p> : null;
    $[40] = isOnline;
    $[41] = t;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== handleHeroSubmit || $[44] !== t11 || $[45] !== t21 || $[46] !== t22 || $[47] !== t5 || $[48] !== t8) {
    t23 = <form method="GET" action={t5} onSubmit={handleHeroSubmit} className="group vortixy-chat-composer--pill relative flex w-full flex-col justify-between bg-[var(--background-elevated)] dark:bg-[color-mix(in_srgb,var(--card)_90%,transparent)] p-3 shadow-[var(--shadow-product)] dark:shadow-[0_20px_50px_rgba(0,0,0,0.7),0_2px_8px_rgba(0,0,0,0.4),inset_0_1px_0_0_rgba(255,255,255,0.12)] transition-[transform,box-shadow] duration-200 hover:-translate-y-[1px] hover:shadow-[var(--shadow-product)] focus-within:-translate-y-[1px] focus-within:outline-none focus-within:ring-2 focus-within:ring-[var(--accent)] focus-within:ring-offset-2 focus-within:ring-offset-background text-foreground">{t6}{t8}{t11}{t21}{t22}</form>;
    $[43] = handleHeroSubmit;
    $[44] = t11;
    $[45] = t21;
    $[46] = t22;
    $[47] = t5;
    $[48] = t8;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t) {
    t24 = t("chatFaqVsManualAnswer");
    $[50] = t;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t24) {
    t25 = <p className="mt-2 text-center text-xs leading-6 text-muted-foreground">{t24}</p>;
    $[52] = t24;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== t23 || $[55] !== t25) {
    t26 = <>{t23}{t25}</>;
    $[54] = t23;
    $[55] = t25;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  return t26;
}
function _temp(e_0) {
  if (e_0.key !== "Enter" || e_0.shiftKey) {
    return;
  }
  if ((e_0.nativeEvent as unknown as {
    isComposing?: boolean;
  }).isComposing || e_0.keyCode === 229) {
    return;
  }
  e_0.preventDefault();
  e_0.currentTarget.form?.requestSubmit();
}